export default {
  path: '/error/404',
  name: 'error-404',
  component: () => import(`./index.vue`),
};
